var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trans-list-wrapper" },
    [
      _c("sec-title", { attrs: { isShowHelp: false } }),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "wallet-trans-list-table",
          attrs: {
            headList: [
              {
                class: "tType",
                text: this.$t("walletTransList.tType.title"),
                cell: "type"
              },
              {
                class: "status",
                text: this.$t("walletTransList.status.title"),
                cell: "status"
              },
              {
                class: "time",
                text: this.$t("walletTransList.timestamp"),
                cell: "date"
              },
              {
                class: "address",
                text: this.$t("walletTransList.tAddress"),
                cell: "transAddr"
              },
              {
                class: "sum",
                text: this.$t("walletTransList.sum"),
                cell: "amount"
              },
              {
                class: "token",
                text: "Token",
                cell: "tokenSymbol"
              }
            ],
            contentList: _vm.transList,
            clickRow: _vm.goDetail
          }
        },
        [
          _vm._l(_vm.transList, function(item, i) {
            return _c("img", {
              key: i,
              staticClass: "icon",
              attrs: {
                slot: i + "typeBefore",
                src:
                  "" +
                  (_vm.txImgs[item.txType]
                    ? _vm.txImgs[item.txType]
                    : _vm.txTransImg)
              },
              slot: i + "typeBefore"
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.transList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                class: {
                  pink: item.statusNum === 0,
                  blue: item.statusNum === 1,
                  green: item.statusNum === 2
                },
                attrs: { slot: i + "statusBefore" },
                slot: i + "statusBefore"
              },
              [_vm._v(_vm._s(item.statusText))]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.transList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                class: {
                  red: item.isSend,
                  green: !item.isSend
                },
                attrs: { slot: i + "amountBefore" },
                slot: i + "amountBefore"
              },
              [_vm._v(_vm._s(item.showAmount))]
            )
          }),
          _vm._v(" "),
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.currentPage + 1,
              totalPage: +_vm.totalPage,
              toPage: _vm.toPage
            },
            slot: "tableBottom"
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }